var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSportsFootball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.0201 15.6204C2.9401 18.0404 3.3401 19.9604 3.6901 20.3104C4.0401 20.6604 5.9701 21.0704 8.3801 20.9804L3.0201 15.6204Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0801 3.28041C10.7501 3.70041 8.2901 4.62041 6.4601 6.46041C4.6301 8.30041 3.7001 10.7504 3.2801 13.0804L10.9101 20.7104C13.2501 20.3004 15.7001 19.3704 17.5301 17.5304C19.3601 15.6904 20.2901 13.2404 20.7101 10.9104L13.0801 3.28041ZM14.8001 10.6004L10.6001 14.8004C10.2101 15.1904 9.5901 15.1904 9.2001 14.8004C8.8101 14.4104 8.8101 13.7904 9.2001 13.4004L13.4001 9.20041C13.7901 8.81041 14.4101 8.81041 14.8001 9.20041C15.1901 9.5904 15.1901 10.2104 14.8001 10.6004Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9801 8.38041C21.0601 5.96041 20.6601 4.04041 20.3101 3.69041C19.9601 3.34041 18.0301 2.93041 15.6201 3.02041L20.9801 8.38041Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsFootball);
export default __webpack_public_path__ + "static/media/SportsFootball.65187dbc678c00bcaa79b176c97f52fa.svg";
export { ForwardRef as ReactComponent };